export { useRelatedAndPromotedEventsLazy } from './useRelatedAndPromotedEventsLazy';
